import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  cardbox: {
    border: '0px',
    boxShadow: '0.25px 0.5px 5px 0px',
  },
});
